<template>
    <FontAwesomeIcon
        v-for="i in icons"
        :key="i.symbol"
        :icon="i.icon"
        :symbol="i.symbol"
    />
</template>
<script setup>
    import { computed } from "vue";
    import { GlobalSymbolIcons } from "@/FaInstaller";

    //icon value of "fas fa-filter" will produce a symbol id of "rq-fas-filter"
    const getIconDetail = icon => ({ icon, symbol: _.getSvgSymbolId(icon) });

    //making a computed in case we want to reference a store value and build it out incrementally via a composable
    const icons = computed(() => _.map(_.uniq(GlobalSymbolIcons), getIconDetail));
</script>